<script setup lang="ts" name="VCardContent">
import type { IVCardContentSpacing } from '~/types';

const { spacing = 'px-6 pb-6' } = defineProps<{
  spacing?: IVCardContentSpacing;
}>();
</script>

<template>
  <div class="h-full" :class="[spacing]">
    <slot />
  </div>
</template>
